export default {"src":"/_next/static/media/error-image.c07c45d2.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};